import { cn } from '@talentmesh/ui/lib/utils';
import React from 'react';

function BodyTypography({ children, className, ...props }: React.ComponentProps<'p'>) {
    return (
        <p className={cn('text-foreground text-base', className)} {...props}>
            {children}
        </p>
    );
}

export default BodyTypography;
